/**
 * Ultimate Trance Landing Page - Shopify Theme
 * JavaScript Functionality
 */

/* Locale-aware root URL for Shopify Markets */
var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

/* Splide instance registry for cleanup */
var splideInstances = [];

/**
 * Lazy-mount a Splide carousel when it's near the viewport.
 * Saves significant CPU by not initializing off-screen carousels on page load.
 * For autoplay carousels, pauses when off-screen and resumes when visible.
 */
function lazyMountSplide(el, options, beforeMount) {
    var initObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                initObserver.unobserve(el);
                var instance = new Splide(el, options);
                if (beforeMount) beforeMount(instance);
                instance.mount();
                splideInstances.push({ el: el, instance: instance });

                /* Pause/resume autoplay when off-screen to save CPU */
                if (options.autoplay) {
                    var visObserver = new IntersectionObserver(function(vEntries) {
                        vEntries.forEach(function(vEntry) {
                            try {
                                if (vEntry.isIntersecting) {
                                    instance.Components.Autoplay.play();
                                } else {
                                    instance.Components.Autoplay.pause();
                                }
                            } catch (e) { /* Autoplay component may not exist */ }
                        });
                    });
                    visObserver.observe(el);
                }
            }
        });
    }, { rootMargin: '200px' });
    initObserver.observe(el);
}

document.addEventListener('DOMContentLoaded', function() {
    /* ===== Phase 1a: Event delegation + lightweight init (deferred to own task) ===== */
    setTimeout(function() {
        initVideoCarousel();
        initVideoTestimonials();
        initProductGallery();

        // ========================================
        // FAQ Accordion
        // ========================================
        var faqLists = document.querySelectorAll('.faq-list');

        faqLists.forEach(function(faqList) {
            var activeItem = faqList.querySelector('.faq-item.active');

            faqList.addEventListener('click', function(e) {
                var question = e.target.closest('.faq-question');
                if (!question) return;

                var item = question.parentElement;
                var answer = item.querySelector('.faq-answer');
                var isActive = item.classList.contains('active');

                // Phase 1: batched reads (all scrollHeight measurements before any writes
                // to avoid forced synchronous layout cascades that spike INP on mobile).
                var prevItem = (activeItem && activeItem !== item) ? activeItem : null;
                var prevAnswer = prevItem ? prevItem.querySelector('.faq-answer') : null;
                var prevQuestion = prevItem ? prevItem.querySelector('.faq-question') : null;
                var prevHeight = prevAnswer ? prevAnswer.scrollHeight : 0;
                var selfHeight = answer ? answer.scrollHeight : 0;

                // Phase 2: writes
                if (prevItem) {
                    if (prevAnswer) {
                        prevAnswer.style.maxHeight = prevHeight + 'px';
                        prevAnswer.setAttribute('aria-hidden', 'true');
                        requestAnimationFrame(function() { prevAnswer.style.maxHeight = '0'; });
                    }
                    prevItem.classList.remove('active');
                    if (prevQuestion) prevQuestion.setAttribute('aria-expanded', 'false');
                }

                if (isActive) {
                    if (answer) {
                        answer.style.maxHeight = selfHeight + 'px';
                        answer.setAttribute('aria-hidden', 'true');
                        requestAnimationFrame(function() { answer.style.maxHeight = '0'; });
                    }
                    item.classList.remove('active');
                    question.setAttribute('aria-expanded', 'false');
                    activeItem = null;
                } else {
                    item.classList.add('active');
                    question.setAttribute('aria-expanded', 'true');
                    if (answer) {
                        answer.setAttribute('aria-hidden', 'false');
                        answer.style.maxHeight = 'none';
                    }
                    activeItem = item;
                }
            });
        });
    }, 0);

    /* ===== Phase 1b: Product options + CTA scaling (deferred to own task) ===== */
    setTimeout(function() {
        // ========================================
        // Product Options Selection (scoped per buy-section)
        // ========================================
        document.querySelectorAll('.buy-section').forEach(function(section) {
            var productOptions = section.querySelectorAll('.product-option');
            var cartPriceEl = section.querySelector('.cart-price');
            var buyProductImage = section.querySelector('[data-buy-product-image]');
            var buyProductImageMobile = section.querySelector('[data-buy-product-image-mobile]');

            if (productOptions.length > 0) {
                var selectOption = function(option) {
                    productOptions.forEach(function(opt) {
                        opt.classList.remove('selected');
                        opt.setAttribute('aria-checked', 'false');
                    });
                    option.classList.add('selected');
                    option.setAttribute('aria-checked', 'true');

                    var price = option.dataset.price;
                    if (cartPriceEl) {
                        cartPriceEl.textContent = price;
                    }

                    var image = option.dataset.image;
                    if (image) {
                        if (buyProductImage) {
                            buyProductImage.style.opacity = '0';
                            setTimeout(function() {
                                buyProductImage.src = image;
                                buyProductImage.style.opacity = '1';
                            }, 150);
                        }
                        if (buyProductImageMobile) {
                            buyProductImageMobile.style.opacity = '0';
                            setTimeout(function() {
                                buyProductImageMobile.src = image;
                                buyProductImageMobile.style.opacity = '1';
                            }, 150);
                        }
                    }
                };

                productOptions.forEach(function(option) {
                    option.addEventListener('click', function() { selectOption(this); });
                    // role="radio" divs need explicit keyboard activation
                    option.addEventListener('keydown', function(e) {
                        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                            e.preventDefault();
                            selectOption(this);
                        }
                    });
                });
            }

        // ========================================
        // Add to Cart via Shopify Cart API (scoped per buy-section)
        // ========================================
            var buyButton = section.querySelector('.buy-button');
            if (buyButton) {
                buyButton.addEventListener('click', function(e) {
                    e.preventDefault();
                    var selectedOption = section.querySelector('.product-option.selected');
                    if (!selectedOption) return;

                    var variantId = selectedOption.dataset.variantId;
                    if (!variantId) return;

                    var btn = this;
                    var _bs = (window.theme && window.theme.strings) || {};
                    // Snapshot the original content once so retry clicks during an
                    // error state never capture the error text as "original".
                    if (!btn.__origNodes) {
                        btn.__origNodes = Array.prototype.slice.call(btn.childNodes).map(function(node) {
                            return node.cloneNode(true);
                        });
                    }
                    btn.disabled = true;
                    btn.textContent = _bs.checking || 'Redirecting...';

                    if (window.themeUtils && typeof window.themeUtils.redirectToCheckout === 'function') {
                        window.themeUtils.redirectToCheckout(variantId).then(function(result) {
                            if (result && result.ok === false) {
                                btn.textContent = _bs.checkoutError || "Couldn't start checkout — tap to retry";
                                setTimeout(function() {
                                    btn.disabled = false;
                                    btn.textContent = '';
                                    btn.__origNodes.forEach(function(node) { btn.appendChild(node.cloneNode(true)); });
                                }, 2500);
                            }
                        });
                        return;
                    }

                    window.location.href = rootUrl + 'checkout';
                });
            }
        }); // end buy-section forEach

        // ========================================
        // CTA Button Auto-Scale (dynamic price sizing)
        // Scales price group based on digit count: short = bigger, long = smaller
        // ========================================
        (function() {
            // Phased reads/writes: all buttons share each layout pass (2 forced
            // layouts total) instead of interleaving per button, which forced a
            // sync reflow for every CTA on load and on each resize tick.
            function scaleCTAPrices() {
                var items = [];

                // Write pass: reset + digit-count scale (textContent doesn't force layout)
                document.querySelectorAll('.btn.cta-main').forEach(function(btn) {
                    var priceGroup = btn.querySelector('.btn-price-group');
                    if (!priceGroup) return;
                    priceGroup.style.fontSize = '';

                    // Count digits in the price text (ignore currency symbols, spaces, punctuation)
                    var digits = (priceGroup.textContent.match(/\d/g) || []).length;

                    // Scale: fewer digits = larger, more digits = smaller
                    var scale;
                    if (digits <= 3) scale = 1.15;
                    else if (digits <= 5) scale = 1.05;
                    else if (digits <= 7) scale = 0.95;
                    else scale = 0.85;
                    priceGroup.style.fontSize = scale + 'em';
                    items.push({ btn: btn, priceGroup: priceGroup });
                });
                if (!items.length) return;

                // Read pass: one layout for every button
                items.forEach(function(it) {
                    var parent = it.btn.parentElement;
                    it.maxWidth = parent ? parent.clientWidth : 0;
                    it.scrollWidth = it.btn.scrollWidth;
                    it.currentSize = parseFloat(getComputedStyle(it.priceGroup).fontSize);
                });

                // Write pass: shrink overflowing buttons
                var shrunk = [];
                items.forEach(function(it) {
                    if (!it.currentSize || it.maxWidth <= 0 || it.scrollWidth <= it.maxWidth) return;
                    it.minSize = it.currentSize * 0.5;
                    it.targetSize = Math.max(it.minSize, Math.floor(it.currentSize * (it.maxWidth / it.scrollWidth) * 10) / 10);
                    if (it.targetSize >= it.currentSize) return;
                    it.priceGroup.style.fontSize = it.targetSize + 'px';
                    shrunk.push(it);
                });
                if (!shrunk.length) return;

                // One final corrective read+write pass handles rounding and inline
                // element differences without the repeated sync layout churn of a
                // shrinking while-loop.
                shrunk.forEach(function(it) {
                    it.correctedWidth = it.btn.scrollWidth;
                });
                shrunk.forEach(function(it) {
                    if (it.correctedWidth > it.maxWidth && it.targetSize > it.minSize) {
                        var finalSize = Math.max(it.minSize, Math.floor(it.targetSize * (it.maxWidth / it.correctedWidth) * 10) / 10);
                        if (finalSize < it.targetSize) {
                            it.priceGroup.style.fontSize = finalSize + 'px';
                        }
                    }
                });
            }
            scaleCTAPrices();
            var _resizeTimer;
            window.addEventListener('resize', function() {
                clearTimeout(_resizeTimer);
                _resizeTimer = setTimeout(scaleCTAPrices, 200);
            });
        })();
    }, 0);

    /* ===== Phase 1c: Event delegation + Splide carousels (deferred to own task) ===== */
    setTimeout(function() {
        function buildCtaAnalytics(btn, fallbackAction) {
            var text = btn.getAttribute('data-ph-capture-attribute-cta-text') || btn.textContent || '';
            text = text.replace(/\s+/g, ' ').trim();
            return {
                cta_action: fallbackAction || btn.getAttribute('data-ph-capture-attribute-cta-action') || btn.dataset.action || '',
                cta_text: text,
                product_title: btn.dataset.productTitle || btn.getAttribute('data-ph-capture-attribute-product') || '',
                product_id: btn.getAttribute('data-ph-capture-attribute-product-id') || '',
                product_handle: btn.dataset.productHandle || btn.getAttribute('data-ph-capture-attribute-product-handle') || '',
                variant_id: btn.dataset.variantId || btn.getAttribute('data-ph-capture-attribute-variant-id') || '',
                cta_surface: btn.closest('.sticky-cta-bar') ? 'sticky_bar' : (btn.closest('.hero-section, .bundle-hero, .hc-hero') ? 'hero' : 'page')
            };
        }

        function recordCtaIntent(btn, fallbackAction) {
            var meta = buildCtaAnalytics(btn, fallbackAction);
            if (window.themeAnalytics) {
                window.themeAnalytics.setCartIntent(meta);
                window.themeAnalytics.capture('cta_clicked', meta);
            }
            return meta;
        }

        // ========================================
        // CTA Add-to-Cart Handler
        // ========================================
        document.addEventListener('click', function(e) {
            var btn = e.target.closest('[data-action="add_to_cart"]');
            if (!btn || btn.disabled) return;

            // Get variant ID (used in multiple code paths below)
            var variantId = btn.dataset.variantId;

            // Check if direct checkout mode should skip popup and go straight to checkout
            if (window.themeUtils && window.themeUtils.isSkipPopupMode()) {
                e.preventDefault();
                btn.disabled = true;
                window.themeUtils.redirectToCheckout(variantId, recordCtaIntent(btn, 'direct_checkout'));
                return;
            }

            // Check if upsell popup should handle this click
            var hasTrigger = btn.hasAttribute('data-trigger-upsell');
            var shouldShowUpsell = window.themeUtils && window.themeUtils.shouldShowUpsell();
            if (hasTrigger && shouldShowUpsell) {
                return; // Let upsell-popup.js handle the click
            }

            // In show_popup_checkout mode, redirect to checkout even without upsell trigger
            if (window.themeUtils && window.themeUtils.shouldDirectCheckout()) {
                e.preventDefault();
                btn.disabled = true;
                window.themeUtils.redirectToCheckout(variantId, recordCtaIntent(btn, 'direct_checkout'));
                return;
            }

            e.preventDefault();

            if (!variantId) {
                console.warn('Add to cart: No variant ID available');
                return;
            }

            recordCtaIntent(btn, 'add_to_cart');

            var savedNodes = Array.prototype.slice.call(btn.childNodes).map(function(node) {
                return node.cloneNode(true);
            });
            var _s = (window.theme && window.theme.strings) || {};
            btn.disabled = true;
            btn.textContent = _s.adding || 'Adding...';

            // Open drawer immediately for instant feedback. cart:added later triggers refreshCart
            // to update contents; openDrawer is idempotent so it's safe if already open.
            var placeholderEl = null;
            if (window.Cart && window.Cart.openDrawer) {
                window.Cart.openDrawer();

                // Optimistic line-item render: slot a placeholder in the drawer using the
                // button's data-attrs so the user sees the item instantly. refreshCart
                // clears the items container and rebuilds from server data, naturally
                // replacing the placeholder with the real entry.
                try {
                    var ctr = window.Cart.itemsContainer;
                    var pTitle = btn.dataset.productTitle;
                    var pImage = btn.dataset.productImage;
                    var pPrice = btn.dataset.productPrice;
                    if (ctr && pTitle) {
                        var emptyEl = ctr.querySelector('.cart-empty');
                        if (emptyEl) emptyEl.remove();

                        var ph = document.createElement('div');
                        ph.className = 'cart-item';
                        ph.setAttribute('data-pending', 'true');

                        var imgWrap = document.createElement('div');
                        imgWrap.className = 'cart-item-image';
                        if (pImage) {
                            var imgEl = document.createElement('img');
                            imgEl.src = pImage;
                            imgEl.alt = pTitle;
                            imgEl.loading = 'eager';
                            imgWrap.appendChild(imgEl);
                        }
                        ph.appendChild(imgWrap);

                        var det = document.createElement('div');
                        det.className = 'cart-item-details';
                        var tt = document.createElement('div');
                        tt.className = 'cart-item-title';
                        tt.textContent = pTitle;
                        det.appendChild(tt);
                        if (pPrice) {
                            var pd = document.createElement('div');
                            pd.className = 'cart-item-price';
                            var pc = document.createElement('span');
                            pc.className = 'cart-item-price-current';
                            pc.textContent = pPrice;
                            pd.appendChild(pc);
                            det.appendChild(pd);
                        }
                        ph.appendChild(det);
                        ctr.appendChild(ph);
                        placeholderEl = ph;
                    }
                } catch (phErr) { /* non-critical: refresh will render correctly */ }
            }

            window.cartOperations.run(function() { return fetch(rootUrl + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
            })
            .then(function(res) {
                if (!res.ok) throw new Error('Cart error');
                return res.json();
            })
            .then(function(data) {
                if (window.__publishAddToCart) window.__publishAddToCart(data);
                // Fire-and-forget Meta click-id cart attributes (no redirect on this path).
                if (window.themeUtils && window.themeUtils.syncClickAttributes) window.themeUtils.syncClickAttributes();
                document.dispatchEvent(new CustomEvent('cart:added'));
                btn.textContent = _s.added || 'Added!';
                setTimeout(function() {
                    btn.disabled = false;
                    btn.textContent = '';
                    savedNodes.forEach(function(node) { btn.appendChild(node); });
                }, 1500);
            }); })
            .catch(function(err) {
                console.error('Cart error:', err);
                if (window.posthog && window.posthog.capture) {
                    window.posthog.capture('cart_add_failed', {
                        variant_id: variantId,
                        error_message: String(err && err.message || err),
                        page_path: window.location.pathname,
                        cta_action: 'add_to_cart'
                    });
                }
                // Roll back the optimistic drawer render so the user never sees
                // a phantom "added" item: drop the placeholder and re-sync the
                // drawer from the real cart (restores the empty state too).
                if (placeholderEl && placeholderEl.parentNode) {
                    placeholderEl.parentNode.removeChild(placeholderEl);
                }
                if (window.Cart && window.Cart.refreshCart) window.Cart.refreshCart();
                btn.textContent = _s.addError || "Couldn't add — try again";
                setTimeout(function() {
                    btn.disabled = false;
                    btn.textContent = '';
                    savedNodes.forEach(function(node) { btn.appendChild(node); });
                }, 2500);
            });
        });

        // ========================================
        // CTA Direct-Checkout Handler
        // ========================================
        document.addEventListener('click', function(e) {
            var btn = e.target.closest('[data-action="direct_checkout"]');
            if (!btn || btn.disabled) return;

            var variantId = btn.dataset.variantId;

            // Check if upsell popup should handle this click
            var hasTrigger = btn.hasAttribute('data-trigger-upsell');
            var shouldShowUpsell = window.themeUtils && window.themeUtils.shouldShowUpsell();
            if (hasTrigger && shouldShowUpsell) {
                return; // Let upsell-popup.js handle the click
            }

            e.preventDefault();
            if (variantId && window.themeUtils) {
                if (!btn.__origNodes) {
                    btn.__origNodes = Array.prototype.slice.call(btn.childNodes).map(function(node) {
                        return node.cloneNode(true);
                    });
                }
                btn.disabled = true;
                window.themeUtils.redirectToCheckout(variantId, recordCtaIntent(btn, 'direct_checkout')).then(function(result) {
                    if (result && result.ok === false) {
                        var _ds = (window.theme && window.theme.strings) || {};
                        btn.textContent = _ds.checkoutError || "Couldn't start checkout — tap to retry";
                        setTimeout(function() {
                            btn.disabled = false;
                            btn.textContent = '';
                            btn.__origNodes.forEach(function(node) { btn.appendChild(node.cloneNode(true)); });
                        }, 2500);
                    }
                });
            }
        });

        // ========================================
        // Smooth Scroll for anchor links
        // ========================================
        document.addEventListener('click', function(e) {
            var link = e.target.closest('a[href^="#"]');
            if (!link) return;

            // Skip if it has upsell trigger or add to cart action
            if (link.hasAttribute('data-trigger-upsell') || link.getAttribute('data-action') === 'add_to_cart') return;

            var href = link.getAttribute('href');
            if (href && href.length > 1) {
                if (href === '#buy') {
                    recordCtaIntent(link, 'scroll_to_buy');
                }

                var target = null;
                try { target = document.querySelector(href); } catch (err) {}

                // If not found directly, try finding Shopify section by key suffix
                // Shopify section IDs can be: shopify-section-{key} OR shopify-section-template--{id}__{key}
                if (!target && href.startsWith('#shopify-section-')) {
                    var sectionKey = href.replace('#shopify-section-', '');
                    // Look for section ending with __{key}
                    target = document.querySelector('[id$="__' + sectionKey + '"]');
                }

                // No matching element: let the browser handle the click natively
                // instead of swallowing it with preventDefault.
                if (!target) return;

                e.preventDefault();
                e.stopPropagation();

                // Calculate offset for sticky header if present
                var header = document.querySelector('.header-section, header');
                var offset = header ? header.offsetHeight : 0;
                var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;

                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        }, true);

        // ========================================
        // Sticky Bar Visibility
        // ========================================
        var stickyBar = document.querySelector('.sticky-cta-bar');
        var heroSection = document.querySelector('.hero-section');

        if (stickyBar && heroSection) {
            stickyBar.style.transition = 'transform 0.3s ease, opacity 0.3s ease';
            // Top-positioned bars hide upward, bottom bars downward
            var stickyHideTransform = stickyBar.className.indexOf('sticky-cta-top') !== -1 ? 'translateY(-100%)' : 'translateY(100%)';

            var heroObserver = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        stickyBar.style.transform = stickyHideTransform;
                        stickyBar.style.opacity = '0';
                    } else {
                        stickyBar.style.transform = 'translateY(0)';
                        stickyBar.style.opacity = '1';
                    }
                });
            }, { threshold: 0.5 });

            heroObserver.observe(heroSection);
        }

        // ========================================
        // Splide Carousel Initialization
        // ========================================
        if (typeof Splide !== 'undefined') {
            document.querySelectorAll('.reviews-splide').forEach(function(el) {
                lazyMountSplide(el, {
                    type: 'loop',
                    perPage: 3,
                    perMove: 1,
                    gap: '24px',
                    pagination: true,
                    arrows: true,
                    autoplay: true,
                    interval: 4000,
                    pauseOnHover: true,
                    pauseOnFocus: true,
                    breakpoints: {
                        1024: { perPage: 2 },
                        768: { perPage: 1, padding: { right: '15%' }, gap: '16px' }
                    }
                });
            });

            // Reviews Grid — Splide (desktop grid, mobile swipe)
            document.querySelectorAll('.reviews-grid-splide').forEach(function(el) {
                var perPage = parseInt(el.dataset.perPage) || 3;
                var gap = parseInt(el.dataset.gap) || 24;
                var cardCount = parseInt(el.dataset.cardCount) || 0;
                var useLoop = cardCount > perPage;
                lazyMountSplide(el, {
                    type: useLoop ? 'loop' : 'slide',
                    perPage: perPage,
                    perMove: 1,
                    gap: gap + 'px',
                    pagination: false,
                    arrows: useLoop,
                    drag: useLoop || window.innerWidth <= 768,
                    breakpoints: {
                        1024: { perPage: Math.min(perPage, 2), drag: true },
                        768: { perPage: 1, padding: { right: '15%' }, gap: '16px', arrows: false, drag: true }
                    }
                }, function(instance) {
                    instance.on('move', function() {
                        var hint = el.querySelector('[data-rg-swipe-hint]');
                        if (hint) hint.style.display = 'none';
                    });
                });
            });
        }
    }, 0);

    /* ===== Phase 2: Observers (deferred to own task) ===== */
    setTimeout(function() {
            // ========================================
            // Intersection Observer for Animations
            // ========================================
            var observer = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('visible');
                        observer.unobserve(entry.target);
                    }
                });
            }, {
                root: null,
                rootMargin: '0px 0px -80px 0px',
                threshold: 0.1
            });

            var revealElements = document.querySelectorAll('.reveal, .feature-card, .review-card, .macro-card, .workflow-step, .bonus-card');
            var isMobileDevice = window.innerWidth <= 768;
            revealElements.forEach(function(el, index) {
                if (!isMobileDevice) el.style.transitionDelay = (index * 0.03) + 's';
                observer.observe(el);
            });

            /* Only observe direct child sections on desktop — skip on mobile for performance */
            if (window.innerWidth > 768) {
                var sections = document.querySelectorAll('section');
                sections.forEach(function(section) {
                    if (!section.classList.contains('reveal')) {
                        section.classList.add('reveal');
                        observer.observe(section);
                    }
                });
            }

            // ========================================
            // Pause off-screen CSS animations (GPU savings)
            // ========================================
            var animSelector = [
                '.animated-border',
                '.sticky-cta-bar',
                '.sticky-cta-border',
                '.vol-badge-border',
                '.hero-logo-vol',
                '.uh-cta-btn',
                '.testimonial-card',
                '.testimonial-container',
                '.testimonial-stroke-border',
                '.comparison-table',
                '.step-badge',
                '.buy-badge',
                '.option-badge',
                '.presets-grid',
                '.ev-card',
                '.pricing-option',
                '.cq-quote strong',
                '.cq-text-highlight',
                '.ab-photo__glow'
            ].join(',');

            var animObserver = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    entry.target.classList.toggle('is-offscreen', !entry.isIntersecting);
                });
            }, { rootMargin: '100px' });

            document.querySelectorAll(animSelector).forEach(function(el) {
                animObserver.observe(el);
            });

            // ========================================
            // Pause animations & backdrop-filter during active scroll
            // Frees GPU for 60fps scroll compositing — animations
            // resume 150ms after scroll stops
            // ========================================
            var scrollTimer;
            var isScrolling = false;
            var htmlEl = document.documentElement;

            window.addEventListener('scroll', function() {
                if (!isScrolling) {
                    isScrolling = true;
                    htmlEl.classList.add('is-scrolling');
                }
                clearTimeout(scrollTimer);
                scrollTimer = setTimeout(function() {
                    isScrolling = false;
                    htmlEl.classList.remove('is-scrolling');
                }, 250);
            }, { passive: true });
    }, 0);
});

// ========================================
// Video Carousel (Splide) for Video Reels
// ========================================
function initVideoCarousel() {
    if (typeof Splide === 'undefined') return;

    document.querySelectorAll('.video-carousel').forEach(function(carousel) {
        if (carousel.dataset.splideInit) return;
        carousel.dataset.splideInit = 'true';

        lazyMountSplide(carousel, {
            type: 'slide',
            perPage: 3,
            perMove: 1,
            gap: '1rem',
            pagination: false,
            arrows: false,
            drag: false,
            breakpoints: {
                1024: {
                    perPage: 2,
                    gap: '1rem',
                    drag: true,
                    pagination: true
                },
                768: {
                    perPage: 2,
                    gap: '0.75rem',
                    drag: true,
                    pagination: true,
                    padding: { left: '1rem', right: '1rem' }
                },
                480: {
                    perPage: 1,
                    gap: '0.75rem',
                    drag: true,
                    pagination: true,
                    padding: { left: '2rem', right: '2rem' },
                    focus: 'center'
                }
            }
        });
    });
}

// ========================================
// Video Testimonials - Play/Pause Handling
// ========================================
function initVideoTestimonials() {
    var videoCards = document.querySelectorAll('.video-card');

    videoCards.forEach(function(card) {
        var wrapper = card.querySelector('.video-wrapper');
        var video = card.querySelector('video');
        var loader = card.querySelector('.video-loader');
        var playOverlay = card.querySelector('.video-play-overlay');

        if (!video || !loader || !playOverlay || !wrapper) return;

        // Track touch for swipe vs tap detection
        var touchStartX = 0;
        var touchStartY = 0;
        var touchStartTime = 0;
        var isSwiping = false;

        wrapper.addEventListener('touchstart', function(e) {
            touchStartX = e.touches[0].clientX;
            touchStartY = e.touches[0].clientY;
            touchStartTime = Date.now();
            isSwiping = false;
        }, { passive: true });

        wrapper.addEventListener('touchmove', function(e) {
            if (isSwiping) return;
            var deltaX = Math.abs(e.touches[0].clientX - touchStartX);
            var deltaY = Math.abs(e.touches[0].clientY - touchStartY);
            if (deltaX > 15 || deltaY > 15) {
                isSwiping = true;
            }
        }, { passive: true });

        wrapper.addEventListener('touchend', function(e) {
            var touchDuration = Date.now() - touchStartTime;
            // Only toggle if it was a quick tap without movement
            if (!isSwiping && touchDuration < 300) {
                e.preventDefault();
                togglePlayPause();
            }
        });

        // Desktop click
        wrapper.addEventListener('click', function(e) {
            // Check if it's a mouse click (not touch)
            if (e.pointerType === 'mouse' || !('ontouchstart' in window)) {
                togglePlayPause();
            }
        });

        // Show loader when video is buffering
        video.addEventListener('waiting', function() {
            loader.classList.add('visible');
        });

        // Hide loader when video can play or is playing
        video.addEventListener('canplay', function() {
            loader.classList.remove('visible');
        });

        video.addEventListener('playing', function() {
            loader.classList.remove('visible');
        });

        // Function to toggle play/pause
        function togglePlayPause() {
            if (video.paused) {
                // Pause all other videos first
                document.querySelectorAll('.video-card video').forEach(function(v) {
                    if (v !== video && !v.paused) {
                        v.pause();
                        v.muted = true;
                        var otherOverlay = v.closest('.video-card').querySelector('.video-play-overlay');
                        if (otherOverlay) otherOverlay.classList.remove('hidden');
                    }
                });

                // Show loader while video loads
                loader.classList.add('visible');
                playOverlay.classList.add('hidden');

                // Unmute and play
                video.muted = false;
                video.play().then(function() {
                    loader.classList.remove('visible');
                }).catch(function() {
                    // If autoplay with sound fails, try muted
                    video.muted = true;
                    video.play();
                    loader.classList.remove('visible');
                });
            } else {
                video.pause();
                video.muted = true;
                playOverlay.classList.remove('hidden');
            }
        }

        // Update overlay when video ends (though we have loop, just in case)
        video.addEventListener('ended', function() {
            playOverlay.classList.remove('hidden');
        });
    });
}

// ========================================
// Product Gallery - Thumbnail click + Splide
// ========================================
function initProductGallery(scope) {
    var root = scope || document;
    var splideEl = root.querySelector('#pt-thumbs-splide');
    if (!splideEl) return;

    // Init Splide on thumbnail strip
    if (typeof Splide !== 'undefined') {
        new Splide(splideEl, {
            type: 'slide',
            perPage: 5,
            perMove: 1,
            gap: '8px',
            pagination: false,
            arrows: true,
            isNavigation: true,
            breakpoints: {
                768: { perPage: 4 },
                480: { perPage: 3 }
            }
        }).mount();
    }

    // Thumbnail click handler
    var mainImage = root.querySelector('#pt-main-image');
    var thumbs = root.querySelectorAll('[data-pt-thumb]');
    if (!mainImage || !thumbs.length) return;

    thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
            // Update active state
            thumbs.forEach(function(t) { t.classList.remove('pt-thumb--active'); });
            this.classList.add('pt-thumb--active');

            // Fade swap main image
            var newUrl = this.dataset.imageUrl;
            var newSrcset = this.dataset.imageSrcset;
            var newAlt = this.dataset.imageAlt;

            mainImage.style.opacity = '0';
            setTimeout(function() {
                mainImage.src = newUrl;
                if (newSrcset) mainImage.srcset = newSrcset;
                if (newAlt) mainImage.alt = newAlt;
                mainImage.style.opacity = '1';
            }, 150);
        });
    });
}

// ========================================
// Shopify Theme Editor Support
// ========================================
document.addEventListener('shopify:section:load', function(event) {
    // Re-init Splide
    var splideEl = event.target.querySelector('.splide');
    if (splideEl && typeof Splide !== 'undefined') {
        var instance = new Splide(splideEl, {
            type: 'loop',
            perPage: 3,
            perMove: 1,
            gap: '24px',
            pagination: true,
            arrows: true,
            autoplay: true,
            interval: 4000,
            pauseOnHover: true,
            pauseOnFocus: true,
            breakpoints: {
                1024: { perPage: 2 },
                640: { perPage: 1 }
            }
        }).mount();
        splideInstances.push({ el: splideEl, instance: instance });
    }

    // Re-init video carousel
    initVideoCarousel();
    initVideoTestimonials();
    initProductGallery(event.target);

    // Re-init waveform players
    if (typeof window.initializeWaveformPlayers === 'function') {
        window.initializeWaveformPlayers();
    }

    // Re-init FAQ
    var faqList = event.target.querySelector('.faq-list');
    if (faqList) {
        var activeItem = faqList.querySelector('.faq-item.active');
        faqList.addEventListener('click', function(e) {
            var question = e.target.closest('.faq-question');
            if (!question) return;
            var item = question.parentElement;
            var answer = item.querySelector('.faq-answer');
            var isActive = item.classList.contains('active');

            var prevItem = (activeItem && activeItem !== item) ? activeItem : null;
            var prevAnswer = prevItem ? prevItem.querySelector('.faq-answer') : null;
            var prevQ = prevItem ? prevItem.querySelector('.faq-question') : null;
            var prevHeight = prevAnswer ? prevAnswer.scrollHeight : 0;
            var selfHeight = answer ? answer.scrollHeight : 0;

            if (prevItem) {
                if (prevAnswer) {
                    prevAnswer.style.maxHeight = prevHeight + 'px';
                    requestAnimationFrame(function() { prevAnswer.style.maxHeight = '0'; });
                }
                prevItem.classList.remove('active');
                if (prevQ) prevQ.setAttribute('aria-expanded', 'false');
            }
            if (isActive) {
                if (answer) {
                    answer.style.maxHeight = selfHeight + 'px';
                    requestAnimationFrame(function() { answer.style.maxHeight = '0'; });
                }
                item.classList.remove('active');
                question.setAttribute('aria-expanded', 'false');
                activeItem = null;
            } else {
                item.classList.add('active');
                question.setAttribute('aria-expanded', 'true');
                if (answer) {
                    answer.style.maxHeight = selfHeight + 'px';
                    answer.addEventListener('transitionend', function handler() {
                        if (item.classList.contains('active')) answer.style.maxHeight = '';
                        answer.removeEventListener('transitionend', handler);
                    });
                }
                activeItem = item;
            }
        });
    }
});

/* Destroy Splide instances when their section is removed (theme editor) */
document.addEventListener('shopify:section:unload', function(event) {
    splideInstances = splideInstances.filter(function(entry) {
        if (event.target.contains(entry.el)) {
            try { entry.instance.destroy(); } catch (e) {}
            return false;
        }
        return true;
    });
});

